import { render, staticRenderFns } from "./treeForm.vue?vue&type=template&id=3988a53a&scoped=true"
import script from "./treeForm.vue?vue&type=script&lang=js"
export * from "./treeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3988a53a",
  null
  
)

export default component.exports